<template src='./new.pug' lang='pug'></template>

<script>
import _ from 'underscore'
import vSelect from 'vue-select'
import { TheMask } from 'vue-the-mask'
import { Money } from 'v-money'
import Datepicker from 'vuejs-datepicker'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import idioma from '../../../../../build/language/index'
import customSorter from '../../../../utils/customSorter.js'
import customValidator from '../../../../utils/customValidator.js'
import looseDeepEqual from '../../../../utils/looseDeepEqual'
import PATHS from '../../../../router/routesMap.js'
import BelvoWidget from './BelvoWidget.vue'
import { getPluggyConnectorCodeByCdBankPersonType } from '../../../../enum/pluggyConnectorsMap.js'
import axios from '../../../../../build/http-requests/axios-common.js'

export default {
  name: 'BankAccountsNew',

  components: {
    vSelect,
    TheMask,
    Money,
    Datepicker,
    PageTitle,
    FilterPortlet,
    ButtonPrimary,
    BelvoWidget
  },

  data () {
    return {
      requestSent: false,
      banks: [],
      establishmentsGroup: [],
      bankSelected: null,
      bankAccount: {
        bank: null,
        name: null,
        accountNumber: null,
        agency: null,
        startBalance: '',
        startBalanceDate: null,
        agencyDigit: null,
        accountDigit: null,
        ativo: true,
        group: null,
        inUse: false,
        ofdaAtivo: false
      },
      operator: {
        accessProfileId: null
      },
      profiles: [],
      inputAgencyDigit: null,
      inputAccountDigit: null,
      maskTokens: {
        D: {
          pattern: /[0-9]/
        },
        X: {
          pattern: /\w/
        }
      },
      idioma: idioma,
      invalid: null,
      moneyMask: {},
      inputDate: null,
      belvoToken: {},
      enableOfdaForm: false,
      ofdaAccountType: 'PF',
      hasLinkIdUpdated: false
    }
  },

  computed: {
    bankAccountToEdit () {
      return this.$store.getters.bankAccounttoEditId
    },
    portletTitle () {
      return this.bankAccountToEdit
        ? this.$t('contaBancaria.titulos.editarContaBancaria')
        : this.$t('contaBancaria.titulos.novaContaBancaria')
    },
    banksList () {
      return _.sortBy(this.banks, function (item) {
        return customSorter.cleanLowerString(item.nome)
      }, 'asc')
    },
    datePickerLanguage () {
      return this.idioma.getDatePickerLanguageObject()
    },
    moneyMaskLength () {
      return this.idioma.getDatePickerLanguage() === 'pt-br' ? 24 : 23
    },
    establishmentsGroupList () {
      return _.sortBy(this.establishmentsGroup, function (item) {
        return customSorter.cleanLowerString(item.nome)
      }, 'asc')
    },
    stylizeGroupLabel () {
      return (option) => {
        let result = null
        if (typeof option === 'object') {
          if (this.label && option[this.label]) {
            result = option[this.label]
          } else {
            result = option['nome']
          }
        } else {
          result = option + ' (' + this.$t('inputTag.labels.novo') + ')'
        }
        return result
      }
    },
    groupInput () {
      return this.bankAccount.group
    },
    showOpenFinance () {
      return this.$store.getters.allowedFuncionalities.includes(4007)
    }
  },

  watch: {
    bankAccount: {
      handler () {
        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, this.bankAccount))
      },
      deep: true
    },
    groupInput () {
      if (this.bankAccount.group && !this.bankAccount.group.nome) {
        this.bankAccount.group = {nome: this.bankAccount.group}
      }
      if (this.bankAccount.group && this.bankAccount.group.nome && this.bankAccount.group.nome.length > 20) {
        this.bankAccount.group.nome = this.bankAccount.group.nome.slice(0, 20)
      } else {
        this.bankAccount.group = this.bankAccount.group
      }
    }
  },

  methods: {
    handleGroupChange (group) {
      this.bankAccount.group = group
    },

    loadBanks () {
      this.$store.dispatch('getBanks')
        .then((response) => {
          this.banks = response.data.data
          this.banks.forEach(bank => {
            bank.label = bank.codigo + '-' + bank.nomeFantasia
          })
          if (this.bankAccountToEdit) {
            this.loadBankAccount()
          } else {
            this.defaultObject = { ...this.bankAccount }
          }
        })
    },

    newBankAccount () {
      let accountCopy = {...this.bankAccount}
      accountCopy.id = this.bankAccountToEdit
      if (typeof accountCopy.startBalance === 'string' && accountCopy.startBalance === '') {
        // seta para zero para indicar que o campo esta vazio (quando em conjunto com a data vazia)
        accountCopy.startBalance = 0
      } else {
        accountCopy.startBalance = this.removeBankAccountMask()
      }
      accountCopy.ofdaAtivo = this.enableOfdaForm
      this.requestSent = true
      this.$store.dispatch('newBankAccount', accountCopy)
        .then((response) => {
          this.$root.$refs.notification.success(response.data.message)
          this.$store.dispatch('setHasUnsavedChanges', false)
          if (this.enableOfdaForm) {
            this.openPluggyWidget()
          } else {
            this.$router.push(PATHS.LIST_BANK_ACCOUNTS)
          }
        })
        .catch((error) => {
          // volta o valor alterado na chamada da requisicao para vazio
          if (typeof this.bankAccount.startBalance === 'number' && this.bankAccount.startBalance === 0) {
            this.bankAccount.startBalance = ''
          }
          this.$root.$refs.notification.error(error.message)
        })
        .finally(() => {
          this.requestSent = false
        })
    },

    removeBankAccountMask () {
      let splittedStartBalance = this.bankAccount.startBalance.toString().split(' ')

      if (this.bankAccount.startBalance && splittedStartBalance.length > 1) {
        return splittedStartBalance[1].replace(/[.,]/g, '').replace(/(\d{2})$/, '.$1')
      }
      return this.bankAccount.startBalance.replace(/[.,]/g, '').replace(/(\d{2})$/, '.$1')
    },

    loadBankAccount () {
      let self = this
      this.$store.dispatch('getBankAccount', this.bankAccountToEdit)
        .then((response) => {
          self.bankAccount.bank = {}
          let bankAccountLoaded = response.data.data
          self.bankAccount.name = bankAccountLoaded.nome
          self.bankAccount.agency = bankAccountLoaded.numAgencia
          self.bankAccount.agencyDigit = bankAccountLoaded.digAgencia
          self.bankAccount.accountDigit = bankAccountLoaded.digConta
          self.bankAccount.accountNumber = bankAccountLoaded.conta
          self.bankAccount.bank.codigo = bankAccountLoaded.banco ? bankAccountLoaded.banco.codigo : null
          self.bankAccount.bank.nome = bankAccountLoaded.banco ? bankAccountLoaded.banco.nome : null
          self.bankAccount.bank.label = bankAccountLoaded.banco.codigo + '-' + bankAccountLoaded.banco.nomeFantasia
          self.bankAccount.startBalance = bankAccountLoaded.saldoInicial !== null ? bankAccountLoaded.saldoInicial.toFixed(2) : ''
          self.bankAccount.startBalanceDate = bankAccountLoaded.dataSaldoInicial
          self.bankAccount.ativo = bankAccountLoaded.ativo
          self.bankAccount.group = bankAccountLoaded.grupo
          self.bankAccount.inUse = bankAccountLoaded.contaEmUso
          self.bankAccount.linkId = bankAccountLoaded.linkId
          self.bankAccount.institutionOFDA = bankAccountLoaded.institutionOFDA
          self.bankAccount.optIn = {...bankAccountLoaded.optIn}
          self.defaultObject = { ...self.bankAccount }
        })
    },

    validate (event) {
      event.preventDefault()
      this.$validator.validateAll('formNew')
        .then((result) => {
          if (result && this.isBalanceFieldsValid()) {
            this.newBankAccount()
          } else {
            this.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'contaBancaria.erro.salvar')
          }
        })
    },

    back () {
      this.$router.push(PATHS.LIST_BANK_ACCOUNTS)
    },

    uniCharCode (event) {
      if (event) {
        let char = event.which || event.keyCode
        // Se o caracter inserido for diferente de 0 a 9 ou X, não deixa cadastrar
        if (!((char >= 96 && char <= 105) || char === 16 || char === 88 || (char >= 48 && char <= 57)) || (event.shiftKey && event.key !== 'X')) {
          if (event.currentTarget.id === 'agencyDigit') {
            this.inputAgencyDigit.value = null
            this.bankAccount.agencyDigit = null
          } else {
            this.inputAccountDigit.value = null
            this.bankAccount.accountDigit = null
          }
        }
      }
    },

    isBalanceFieldsValid () {
      let isValid = (this.$refs.money.$el.value !== '' && this.bankAccount.startBalanceDate !== null) ||
          (this.$refs.money.$el.value === '' && this.bankAccount.startBalanceDate == null)

      if (!isValid) {
        if (this.$refs.money.$el.value === '') {
          this.errors.add('startBalance', 'balance')
          this.errors.remove('startBalanceDate')
        } else {
          this.errors.add('startBalanceDate', 'balance')
          this.errors.remove('startBalance')
        }
      } else {
        this.errors.remove('startBalance')
        this.errors.remove('startBalanceDate')
      }
      return isValid
    },

    // Evento para interação com o datepicker
    input () {
      this.validateDate()
    },

    validateDate () {
      let isValid = this.inputDate.value.length === 10 &&
        customValidator.isValidDate(this.inputDate.value)
      if (!isValid) {
        this.$refs.startBalanceDate.$children
          .find(item => !!item.id).typedDate = ''
      }
    },

    loadEstablishmentGroups () {
      this.$store.dispatch('getEstablishmentGroups')
        .then((response) => {
          this.establishmentsGroup = response
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error.message)
        })
    },

    getlinkIdLoaded () {
      return this.bankAccount !== null ? this.bankAccount.linkId : null
    },

    loadScript (src) {
      return new Promise((resolve, reject) => {
        if (window.PluggyConnect) {
          return resolve() // Já carregado
        }

        const script = document.createElement('script')
        script.src = src
        script.async = true
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },

    openPluggyWidget () {
      let self = this
      this.loadScript('https://cdn.pluggy.ai/pluggy-connect/v2.8.2/pluggy-connect.js')
      axios.post('/ofda/generatePluggyAccessToken', {}).then((response) => {
        let userToken = response.data
        let widgetConfig = {
          connectToken: userToken.accessToken,
          includeSandbox: false,
          onSuccess: (connection) => {
            this.startLinkUpdate(connection)
          },
          onEvent: (event) => {
            switch (event.event) {
              case 'ITEM_RESPONSE':
                if (!self.hasLinkIdUpdated) {
                  self.hasLinkIdUpdated = true
                  if (self.bankAccount) {
                    self.registerLink(event.item)
                  }
                }
                break
              default:
                break
            }
          },
          onClose: () => {
            this.$router.push(PATHS.LIST_BANK_ACCOUNTS)
          }
        }

        let connectorIds = getPluggyConnectorCodeByCdBankPersonType(this.bankAccount.bank.codigo, this.ofdaAccountType)
        if (connectorIds.length === 1) {
          widgetConfig.selectedConnectorId = connectorIds[0]
        } else {
          widgetConfig.connectorIds = connectorIds
        }

        self.pluggyInstance = new window.PluggyConnect(widgetConfig)
        self.pluggyInstance.init()
      }).catch((err) => {
        self.$root.$refs.notification.error(err.message)
      })
    },

    registerLink (item) {
      let account = {
        id: this.bankAccountToEdit,
        bank: this.bankAccount.bank,
        name: this.bankAccount.name,
        accountNumber: this.bankAccount.accountNumber,
        agency: this.bankAccount.agency,
        linkId: item.id,
        linkIdOld: this.bankAccount && this.bankAccount.optIn ? this.bankAccount.optIn.linkId : null,
        institutionOFDA: item.connector.id
      }

      axios.post('/bankAccounts/linkAccoutToOFDA', account).then((responseSaveAcc) => {
        this.$root.$refs.notification.info('ItemId associado ao optIn da conta com sucesso.')
      }).catch(() => {
        this.$root.$refs.notification.error('Erro ao associar ItemId a conta bancaria.')
      })
    },

    startLinkUpdate () {
      let account = {...this.bankAccount}
      account.id = this.bankAccountToEdit
      account.startBalance = null

      axios.post('/bankAccounts/activateOptIn', account).then((responseSaveAcc) => {
        this.$root.$refs.notification.info('Ativação do opt-in realizada com sucesso.')
      }).catch(() => {
        this.$root.$refs.notification.error('Erro ao iniciar ativação do opt-in.')
      })
    }
  },

  mounted () {
    this.inputAgencyDigit = document.getElementById('agencyDigit')
    this.inputAgencyDigit.addEventListener('keyup', this.uniCharCode, event)
    this.inputAccountDigit = document.getElementById('accountDigit')
    this.inputAccountDigit.addEventListener('keyup', this.uniCharCode, event)
    this.moneyMask = this.idioma.getMoneyMaskByLanguage()
    setTimeout(() => {
      this.inputDate = document.getElementById('startBalanceDate')
      if (this.inputDate) {
        this.inputDate.setAttribute('autocomplete', 'off')
        this.inputDate.addEventListener('blur', () => {
          this.validateDate()
        })
      }
    }, 100)
  },

  created () {
    this.loadBanks()
    this.loadEstablishmentGroups()
  },

  beforeDestroy () {
    this.$store.dispatch('setHasUnsavedChanges', false)
    this.$store.dispatch('cleanBankAccountToEdit')
  }
}

</script>

<style>
.note-card {
  font-family: 'Inter', serif;
  font-style: italic;
  font-size: 12px;
  color: #666;
  padding-top: 20px;
}

.date-picker {
  border: none;
  height: 26px;
  margin-top: 5px;
}

.margin-datepicker-error-msg {
  margin-top: 10px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// New.vue?7835aae1